module.exports = __webpack_public_path__ + "img/heaticon.33ae89f6.jpg";